import React from "react";
import { XIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { afterItems, beforeItems } from "../data/page";
export function BeforeAfterSection() {
  return <section className="bg-surface px-4 py-16 sm:px-6 sm:py-24" data-id="element-37" data-mp="pp3ljuk41hb5">
      <div className="mx-auto max-w-6xl" data-id="element-38" data-mp="kw0vvxiges08">
        <SectionHeading title="From scattered references to a more organized assessment workflow" subtitle="You don't need more disconnected information. You need a clearer way to organize what you already know." data-id="element-39" data-mp="kv91gq0lf0bj" />

        <div className="mt-12 grid gap-6 md:grid-cols-2" data-id="element-40" data-mp="18mwnoumwtn7h">
          <div className="overflow-hidden rounded-3xl bg-white ring-1 ring-alert/20" data-id="element-41" data-mp="18kadsocjqvm3">
            <div className="flex items-center gap-3 bg-alert px-6 py-4 text-white" data-id="element-42" data-mp="13lgzitpfr0kv">
              <XIcon className="h-7 w-7" strokeWidth={3} aria-hidden="true" data-id="element-43" data-mp="3aejd4rr5la1u" />
              <h3 className="font-display text-2xl font-bold uppercase" data-id="element-44" data-mp="35fzq0o0tps7w">Before</h3>
            </div>
            <ul className="divide-y divide-alert/10 px-6 py-2" data-id="element-45" data-mp="36pkzpv14033r">
              {beforeItems.map(item => <li key={item} className="flex gap-3 py-4" data-id="element-46" data-mp="3bo4jppw574th">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-alert-soft text-alert" data-id="element-47" data-mp="3gm62satkj44y">
                    <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-48" data-mp="3le7lofl8rt3y" />
                  </span>
                  <span className="text-base leading-relaxed text-ink-soft" data-id="element-49" data-mp="3pehq3ntdybgp">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="overflow-hidden rounded-3xl bg-navy-900 text-white" data-id="element-50" data-mp="379s56ksp6up">
            <div className="flex items-center gap-3 bg-success px-6 py-4" data-id="element-51" data-mp="86w2n898o8zt">
              <CheckIcon className="h-7 w-7" strokeWidth={3} aria-hidden="true" data-id="element-52" data-mp="84tg4y7aoxzu" />
              <h3 className="font-display text-2xl font-bold uppercase leading-tight" data-id="element-53" data-mp="250qxg3lgdvma">With the Blueprint™</h3>
            </div>
            <ul className="divide-y divide-white/10 px-6 py-2" data-id="element-54" data-mp="2a03t9duayd10">
              {afterItems.map(item => <li key={item} className="flex gap-3 py-4" data-id="element-55" data-mp="1wyhx03fhasom">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-success text-white" data-id="element-56" data-mp="1x01etygs9bsi">
                    <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-57" data-mp="2btedt51csodb" />
                  </span>
                  <span className="text-base leading-relaxed text-white/90" data-id="element-58" data-mp="2kwff8sf9xran">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-12 max-w-3xl space-y-3 text-center text-lg leading-relaxed text-ink-soft" data-id="element-59" data-mp="2fx2mxs5mvs0o">
          <p className="font-semibold text-ink" data-id="element-60" data-mp="2uo33ylkg4u8f">The difference isn't a promise of perfect clinical decisions.</p>
          <p data-id="element-61" data-mp="33mwx21ykj2h8">
            It's having a more organized educational reference to consult when reviewing the many elements involved in
            diabetic foot assessment.
          </p>
        </div>

        <div className="mt-10" data-id="element-62" data-mp="3i9m4qr2z4lyp">
          <CtaButton label="I want a structured approach" data-id="element-63" data-mp="3i9doqqbk10ja" />
        </div>
      </div>
    </section>;
}